import React from 'react';
import { CalendarDays, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { useApp } from '../context/AppContext';
import { blogPosts, blogSection } from '../mock/content';
import useSEO from '../hooks/useSEO';

const BlogList = () => {
  const { lang } = useApp();
  const s = blogSection[lang] || blogSection.en;
  useSEO(`${s.title} | CAB.TAXI Zürich`, s.subtitle);
  return (
    <Layout bookingTop>
      <section className="py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mb-10">
            <h1 className="text-4xl font-extrabold text-[color:var(--brand-dark)]">{s.title}</h1>
            <p className="mt-4 text-gray-500 leading-relaxed">{s.subtitle}</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogPosts.map((p) => {
              const loc = p[lang] || p.en;
              return (
                <Link to={`/blog/${p.slug}`} key={p.slug} className="card-hover group bg-white rounded-2xl overflow-hidden flex flex-col border border-gray-100">
                  <div className="relative h-48 overflow-hidden">
                    <img src={p.img} alt={loc.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                    <span className="absolute top-3 left-3 text-[11px] font-bold px-2.5 py-1 rounded-full text-white" style={{ backgroundColor: 'var(--brand-accent)' }}>{p.tag}</span>
                  </div>
                  <div className="p-5 flex flex-col flex-1">
                    <div className="flex items-center gap-1.5 text-xs text-gray-400 mb-2"><CalendarDays className="w-3.5 h-3.5" /> {p.date}</div>
                    <h2 className="font-bold text-[color:var(--brand-dark)] leading-snug">{loc.title}</h2>
                    <p className="mt-2 text-sm text-gray-500 leading-relaxed flex-1">{loc.excerpt}</p>
                    <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[color:var(--brand-dark)]">{s.read} <ArrowRight className="w-4 h-4" style={{ color: 'var(--brand-accent-hover)' }} /></span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default BlogList;
